const error = {
    // 通用错误吗
    "-1": "内部错误",
    "-6": "对不起，登录信息无效，请重新登录",
    1: "对不起，服务器出错了，请稍后再试",
    2: "系统繁忙，请稍候再试"
};

export default function (res) {
    if (res.status > 300) {
        window.globalVue.$Message.error({
            content: res.statusText
        });
        return;
    } else if (!res.data && res.data.code != 200) {
        // window.globalVue.$Message.error({
        //     content: res.data.msg
        // });
        return Promise.reject(res);
    }
    return res;
}